import { jsx } from 'react/jsx-runtime';
import { TourProvider } from '@reactour/tour';
import { styles, badgeContent } from '../utils/tour.js';

const PortalTour = ({
  children,
  steps = [],
  ...rest
}) => /* @__PURE__ */ jsx(TourProvider, { ...rest, steps, badgeContent, disableDotsNavigation: true, showDots: false, styles, children });

export { PortalTour };
